import type { LocationSource } from '@ngsos/portal-core/realtime';

const icons = {
  Entered: 'Images/Icons/map-manual.svg',
  Aml: 'Images/Icons/map-aml.svg',
  AppleEed: 'Images/Icons/map-apple-eed.svg',
  MobileApp: 'Images/Icons/map-device.svg',
  MobileAppSms: 'Images/Icons/map-device.svg',
  WebApp: 'Images/Icons/map-device.svg',
  GoogleEls: 'Images/Icons/map-device.svg',
} as const satisfies Record<LocationSource, string>;

export function locationSourceIcon(source: LocationSource): string {
  const icon: string | undefined = icons[source];
  if (icon === undefined) {
    throw new Error(`${String(source)} is unknown LocationSource`);
  }

  return icon;
}
